'use strict';

/**
 * Add the ability for test suites to manually set support flags
 * to better test more environments.
 */
const supportsFlags = {};

exports.supportsFlags = supportsFlags;
//# sourceMappingURL=flags.cjs.map
